// extracted by mini-css-extract-plugin
export var avatar = "_qn-3";
export var avatarContainer = "_qn-2";
export var avatarSpacer = "_qn-5";
export var avatarSpacerContainer = "_qn-4";
export var avatarStackContainer = "_qn-1";
export var bubble = "_qn-0";
export var remainderBubble = "_qn-6";